import { useState } from "react";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import { HiPlus } from "react-icons/hi";
import useWindowDimensions from "../../../../hooks/useWindowSize";

const Container = styled.div`
  cursor: pointer;
  background-color: ${({ theme, isHover }) =>
    isHover ? "var(--color-main)" : theme.secondaryBgColor};
  position: relative;
  overflow: hidden;
  border-radius: 20px;
  border: 1px solid transparent;

  .navlink {

    width: 175px;
    height: 80px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 20px;
    align-items: center;
    color: ${({ theme, isHover }) =>
      isHover ? "#F4F4F4" : theme.mainTextColor};

    img {
      width: 25px;
      height: 25px;
      margin: 4px;
    }

    .item-text {
      font-size: 16px;
      font-weight: 600;
      line-height: 19px;
      color: inherit;
    }
    .item-quantity {
      font-size: 16px;
      font-weight: 600;
      color: inherit;
      line-height: 19px;
    }

    .notification-container {
      position: absolute;
      top: 0;
      right: 0;
      width: 36px;
      height: 33px;
      background: var(--color-light);
      box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
      border-radius: 0px 20px;
      background-color: ${({ isHover }) => (isHover ? "#F4F4F4" : "var(--color-main)")};
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        color: ${({ isHover }) => (isHover ? "var(--color-main)" : "#F4F4F4")};
      }
    }
  }

  .yuk-ekle {
    width: 175px;
    height: 80px;
    display: flex;
    justify-content: center;
    gap: 5px;
    border-radius: 20px;
    align-items: center;
    color: ${({ theme, isHover }) => isHover ? "#F4F4F4" : theme.mainTextColor};

    .modal {
      width: 100vw !important;
      height: 100vh !important;
      border-radius: 0;
    }
  }

  .plus-icon {
    font-size: 1.4rem;
  }
  .item-text {
    font-size: 16px;
    font-weight: 600;
    line-height: 19px;
  }

  .active {
    border: 1px solid var(--color-main);
  }


//! ******************************************************************************************

  @media (max-width: 1850px) {

    .navlink{
      width: 160px !important;

      img{

        width: 22px !important;
        height: 22px !important;
      }

      .item-text {
        font-size: var(--font-size-sm);
      }

      .item-quantity {
        font-size: var(--font-size-sm);
      }

      .notification-container{
        width: 30px;
        height: 28px;
        font-size: var(--font-size-sm);
      }
    }
    

    .yuk-ekle{
      width: 160px !important;
      font-size: var(--font-size-sm) !important;

      .item-text{
        font-size: var(--font-size-sm) !important;

      }

      .plus-icon {
        width: 22px !important;
        height: 22px !important;
      }
    }

  }

  @media (max-width: 1700px) {

    .navlink{
      width: 130px !important;
      height: 70px !important;
    }

    .yuk-ekle{
      width: 140px !important;
      height: 70px !important;
      

    }
}
`;

const TopbarMenuItem = ({ item }) => {
  const [isHover, setIsHover] = useState(false);
  const { theme } = useSelector((state) => state.layout);
  const {windowDimensions} = useWindowDimensions()
  
  return (
    <Container
      isHover={isHover}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      {item.id !== 0 ? (
        <NavLink
          to={item.path}
          className={({ isActive }) =>
            isActive ? "active navlink" : "navlink"
          }
        >
          <img
            src={
              isHover ?  item.imgLight :
              theme === "dark" ? item.imgLight : item.imgDark 
            }
            alt=""
          />
          <div className="item-text">{windowDimensions.width <= 1700 ? item.smText : item.text}</div>
          <div className="item-quantity">{item.quantity}</div>
          {item.notifications > 0 && (
            <div className="notification-container">
              <span>{item.notifications}</span>
            </div>
          )}
        </NavLink>
      ) : (
        <NavLink
          to={item.path}
          className={({ isActive }) =>
            isActive ? "active yuk-ekle" : "yuk-ekle"
          }
        >
          <HiPlus className="plus-icon" />
          <div className="item-text">{item.text}</div>

          {item.notifications > 0 && (
            <div className="notification-container">
              <span>{item.notifications}</span>
            </div>
          )}
        </NavLink>
      )}
    </Container>
  );
};

export default TopbarMenuItem;
